import { useCallback } from "react";
import { useFlowContext } from "../providers/FlowProvider";
import { canvasPositionOf } from "../utils/canvasPosition";

interface IUsePosition {
  getPosition: () => { x: number; y: number };
}

export function usePosition(): IUsePosition {
  const { nodes } = useFlowContext();

  const getPosition = useCallback(() => {
    if (nodes.length === 0) {
      return {
        x: 100,
        y: 100,
      };
    }
    // Canvas spots, not the notebook view's cell slots: the new node is placed on the canvas.
    const maxX = Math.max(...nodes.map((node) => canvasPositionOf(node).x));
    const maxY = Math.max(...nodes.map((node) => canvasPositionOf(node).y));
    return {
      x: maxX + 800,
      y: maxY,
    };
  }, [nodes]);

  return { getPosition };
}
